import { catalogs } from "./locales/index.js";

export const SUPPORTED_LOCALES = ["nl", "en"];
export const DEFAULT_LOCALE = "nl";
export const FALLBACK_LOCALE = "en";

const PARAM_PATTERN = /\{\{\s*(\w+)\s*\}\}/g;

/**
 * @param {string | undefined} locale
 * @returns {string}
 */
export function normalizeLocale(locale) {
  const base = String(locale || DEFAULT_LOCALE).split("-")[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(base) ? base : DEFAULT_LOCALE;
}

/**
 * @param {import("./catalogTypes.js").MessageCatalog | undefined} catalog
 * @param {string} key
 * @returns {string | undefined}
 */
function lookupMessage(catalog, key) {
  if (!catalog || !key) {
    return undefined;
  }

  return key.split(".").reduce((node, part) => {
    if (node && typeof node === "object" && part in node) {
      return node[part];
    }
    return undefined;
  }, catalog);
}

/**
 * @param {string} template
 * @param {Record<string, string | number | undefined | null>} [params]
 * @returns {string}
 */
export function interpolate(template, params = {}) {
  return template.replace(PARAM_PATTERN, (_, name) => {
    const value = params[name];
    return value === undefined || value === null ? "" : String(value);
  });
}

/**
 * @param {string} key
 * @param {string | undefined} [locale]
 * @param {Record<string, string | number | undefined | null>} [params]
 * @returns {string}
 */
export function t(key, locale = DEFAULT_LOCALE, params) {
  const resolvedLocale = normalizeLocale(locale);
  const primary = lookupMessage(catalogs[resolvedLocale], key);
  const fallback = resolvedLocale === FALLBACK_LOCALE
    ? undefined
    : lookupMessage(catalogs[FALLBACK_LOCALE], key);
  const message = primary ?? fallback ?? key;

  return params ? interpolate(message, params) : message;
}

/**
 * BCP-47 tag for Intl formatters.
 * @param {string | undefined} locale
 * @returns {string}
 */
export function localeTag(locale) {
  return normalizeLocale(locale) === "nl" ? "nl-NL" : "en-US";
}
